import actions from "actions";
import ActionTypes from "actions/ActionTypes";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { createLoadingSelector } from "reducers/selectors";
import { bindActionCreators, Dispatch } from "redux";
import { SiteManagerProps, SiteTitleProps } from "../type";
import { useHistory, useLocation } from "react-router-dom";
import "../styles/sitemanager.scss";
import { Container } from "reactstrap";
import SiteListing from "./container/SiteListing";
import t from "utils/Lang";

const loadingSelector = createLoadingSelector([
  ActionTypes.SITE_STATISTIC_PREFIX,
]);

const initialStatistic: any = null;

const Title = ({ label, icon }: SiteTitleProps) => {
  return (
    <div className="site-title-container">
      {icon && <img src={icon} />}
      <span className="site-title">{label}</span>
    </div>
  );
};

const breadDefault = { label: t().site_listing__site, path: "/sitev2" };

const SiteManager = ({
  loading,
  siteStatistic,
  setBreadcrumbs,
  user,
}: SiteManagerProps) => {
  const location = useLocation();
  const history = useHistory();
  const [currentStatistic, setCurrentStatistic] = useState(initialStatistic);
  useEffect(() => {
    setBreadcrumbs([breadDefault]);
  }, []);
  useEffect(() => {
    const status = location.search.split("=")?.[1];
    updateBreadcrumbs(status);
    setCurrentStatistic(status);
  }, [location]);
  const updateBreadcrumbs = (status: string) => {
    const statistic = siteStatistic?.find((s) => s.id.toString() == status);
    if (statistic) {
      const breads = [breadDefault];
      breads.push({
        label: statistic?.name,
        path: `/sitev2?statistic=${status}`,
      });
      setBreadcrumbs(breads);
    }
  };
  const onChangeStatus = (status: string) => {
    if (status) history.push(`/sitev2?statistic=${status}`);
  };
  const onSiteClick = (site: any) => {
    const breads = [breadDefault];
    const statistic = siteStatistic?.find(
      (s) => s.id.toString() == currentStatistic
    );
    if (statistic) {
      breads.push({
        label: statistic?.name,
        path: `/sitev2?statistic=${currentStatistic}`,
      });
    }
    breads.push({
      label: site?.name || "Chưa có tên",
      path: `/sitev2/${site.id}`,
    });
    setBreadcrumbs(breads);
    history.push(`/sitev2/${site.id}`);
  };

  return (
    <Container style={{ paddingTop: 10 }}>
      <SiteListing
        onSiteClick={onSiteClick}
        status={currentStatistic}
        onChangeStatus={onChangeStatus}
        siteStatistic={siteStatistic}
        userBrand={user?.user_brand}
      />
    </Container>
  );
};

const mapStateToProps = (state: any) => {
  return {
    loading: loadingSelector(state),
    siteStatistic: state.site.siteStatistic,
    user: state.user.data,
  };
};

const mapActionsToProps = (dispatch: Dispatch) =>
  bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapActionsToProps)(SiteManager);
